import { Field } from 'react-final-form'
import { FinalFormInput } from '../Input'

export default function FormInput(props) {
  const { name } = props
  return <Field name={name} component={FinalFormInput} {...props} />
}
